import { TranslationMode } from '../dto/translation-mode';
import type { EnabledLanguagePairDto, UserPreferencesDto } from '../dto/user-preferences-dto';
import { httpArg, httpGet, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

@httpRoute('/api/users')
export abstract class IUserPreferencesService {
	@httpGet('get-preferences')
	getUserPreferences(@httpUserId() userId: string): Promise<UserPreferencesDto | null> {
		void userId;
		throw new Error('Not implemented');
	}

	@httpPost('set-preferences')
	setUserPreferences(
		@httpUserId() userId: string,
		@httpArg('preferences') preferences: UserPreferencesDto
	): Promise<void> {
		void userId;
		void preferences;
		throw new Error('Not implemented');
	}

	@httpGet('enabled-language-pairs')
	getEnabledLanguagePairs(@httpArg('mode') mode?: TranslationMode): Promise<readonly EnabledLanguagePairDto[]> {
		void mode;
		throw new Error('Not implemented');
	}
}
